import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { showDialog } from '../Features/Auth/AuthSlice';

const TokenExpiryDialog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const eventId = useSelector((state) => state.currentEvent.eventId);
  const isDialogVisible = useSelector((state) => state.auth.showDialog);

  const handleClose = () => {
    dispatch(showDialog(false));
    navigate(`/events/${eventId}/login`);
  };

  if (!isDialogVisible) return null;

  return (
    <div className="dialog">
      <p>Your session has expired. Please log in again.</p>
      <button onClick={handleClose}>Go to Login</button>
    </div>
  );
};

export default TokenExpiryDialog;
